module.exports = __webpack_public_path__ + "img/list01.a746eb0c.png";